var render = function render(){var _vm=this,_c=_vm._self._c;return _c('loader',_vm._b({},'loader',{ loading: _vm.loading },false),[_c('div',{attrs:{"id":"top-techs-chart"}},[_c('apexchart',_vm._b({attrs:{"type":"bar","height":"350"}},'apexchart',{ options: _vm.options, series: _vm.series },false))],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }